import React from "react";
import { SingleSelect } from "@coverme/forms";
import { first } from "lodash-es";

export const PhoneTypeSelect = ({
    name,
    id,
    errors,
    touched,
    setFieldValue,
    value,
    title,
    placeholder,
    onChange,
    setFieldTouched,
    validState,
    errorMessage,
    onFieldChange,
    disabled,
    ...props
}) => {
    const options = [
        { value: "Home", label: "Home" },
        { value: "Cell", label: "Cell" },
        { value: "Work", label: "Work" },
    ];
    let selectedValue = first(options.filter(x => x.value === value)) || "";
    return (
        <SingleSelect
            {...props}
            title={"Phone Type"}
            placeholder={"Phone Type"}
            value={selectedValue}
            id={id}
            onChange={e => {
                setFieldValue(name, e.value);
                if (onFieldChange != null) {
                    onFieldChange(e.value);
                }
            }}
            isDisabled={disabled}
            options={options}
            validState={validState}
            errorMessage={errorMessage}
            onBlur={() => setFieldTouched(name)}
        />
    );
};
